import clsx from 'clsx'
import { smsSegmentInfo, stripHtmlToText } from 'utils/html-text'

export interface SmsSegmentCounterProps {
	/** HTML source to derive the count from (stripped to plain text first) */
	html?: string
	/** Already-plain-text source (e.g. a dedicated SMS textarea) — takes precedence over `html` and skips stripping */
	text?: string
	className?: string
}

export function SmsSegmentCounter({ html, text, className }: SmsSegmentCounterProps) {
	const plainText = text ?? stripHtmlToText(html ?? '')
	const { segments } = smsSegmentInfo(plainText)
	const exceedsSingleSegment = segments > 1

	return (
		<div className={clsx('text-xs', exceedsSingleSegment ? 'text-warning' : 'text-secondary-text', className)}>
			{plainText.length.toLocaleString()} {plainText.length === 1 ? 'character' : 'characters'} ·{' '}
			{segments.toLocaleString()} SMS {segments === 1 ? 'segment' : 'segments'} (approx.)
		</div>
	)
}
